import classNames from 'classnames';
import { Avatar, Button, Card, message } from 'antd';
import dayjs from 'dayjs';
import { useCallback } from 'react';
import { KeyValue } from 'components/common/KeyValue';
import { Profit } from 'components/common/Profit';
import { useOrderActions } from 'hooks/api';

import styles from './index.module.scss';

export interface OrderInfoProps {
  order: Order.Item
  className: string;
}

export const OrderInfo = ({ order, className }: OrderInfoProps) => {
  const { process } = useOrderActions();
  const handleProcess = useCallback(() => {
    process({ orderId: order._id }, { onSuccess: () => message.success('Order successfully processed!') });
  }, []);
  const renderItem = useCallback((item: Order.OrderItem, idx) => (
    <div key={idx.toString()} className={styles.item}>
      <div className={styles.avatar}>
        <Avatar src={item.product.image} />
        <div className={styles.avatarTitle}>
          {item.product.name}
          &nbsp;
          $
          {item.displayName || item.originPrice / 100}
        </div>
        <Profit value={item.profit / 100} />
      </div>
      <KeyValue title='Amount' value={`x${item.amount}`} />
      <KeyValue title='Price' value={`$${item.price / 100}`} />
      {item.delivered ? '(DELIVERED)' : null}
    </div>
  ), []);
  return (
    <Card
      title='Order info'
      className={classNames(styles.card, className)}
      actions={[
        <Button type='primary' onClick={handleProcess}>Process order</Button>,
        <Button disabled type='primary'>Cancel order</Button>,
      ]}
    >
      <KeyValue title='Id' value={order._id} />
      <KeyValue title='Status' value={order.status} />
      <KeyValue title='Ip' value={order.ip} />
      <KeyValue title='Created date' value={dayjs(order.createdAt).format('MMMM D, YYYY h:mm A')} />
      <KeyValue title='Profit' className={styles.profit} value={`$${(order.profit / 100).toFixed(2).toString()}`} />
      <Card title='Items info'>
        <div className={styles.items}>
          {order.items.map(renderItem)}
        </div>
      </Card>
    </Card>
  );
};
